import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import Hero from '../home/components/Hero';
import ServiceTypesSection from '../home/components/ServiceTypesSection';
import Services from '../home/components/Services';

export default function ReparationFenetreSaintFons() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <Hero
        title="Réparation de Fenêtres à Saint-Fons"
        subtitle="Service professionnel de réparation et dépannage de fenêtres à Saint-Fons (69190). Intervention rapide pour tous types de fenêtres : PVC, bois, aluminium."
        backgroundImage="https://public.readdy.ai/ai/img_res/c396c9e8643649e8fb6a886f1c3c7230.jpg"
      />
      
      <ServiceTypesSection />
      
      <Services />
      
      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 text-center mb-12">
            Pourquoi Nous Choisir à Saint-Fons ?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-time-line', title: 'Intervention Rapide', desc: 'Sous 24h à Saint-Fons' },
              { icon: 'ri-shield-star-line', title: 'Garantie Qualité', desc: 'Travaux garantis 2 ans' },
              { icon: 'ri-money-euro-circle-line', title: 'Devis Gratuit', desc: 'Sans engagement' },
              { icon: 'ri-customer-service-2-line', title: 'Disponible 7j/7', desc: 'À votre écoute' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <Contact />
      
      <Footer />
    </div>
  );
}